// @vendors
import React, { useState } from 'react';
import { toast } from 'react-toastify';

// @services
import servicioService from '../../../services/servicioService';
import { PAYMENT_STATUS } from '../../../utils/ConstantsUtils';

const ChargeByCompany = ({
    isOpen,
    onClose,
    companySelected,
    onChargeSuccess,
    formatCurrency
}) => {
    const [step, setStep] = useState(1);
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setStep(1);
        setPassword('');
        onClose();
    };

    const handleConfirm = () => {
        setStep(2);
    };

    const handleCancel = () => {
        handleClose();
    };

    const handleProcessCharge = async () => {
        if (!password.trim()) return toast.error('Por favor ingresa la contraseña');
        try {
            setLoading(true);
            const chargeData = {
                companyId: companySelected.companyId,
                totalLeadsCost: companySelected.costoLeads,
                amountDue: companySelected.amountDue,
                transactionStatus: companySelected.serviceStatus,
                paymentDate: null,
                serviceCount: companySelected.totalServicios
            };
            await servicioService.processCharge(chargeData, password, companySelected.id);
            onChargeSuccess();
            handleClose();
        } catch (error) {
            if (error.response.data.message) return toast.error(error.response.data.message);
            toast.error('Error al procesar el cobro. Por favor intenta de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-800">
                        {step === 1 ? 'Confirmar Cobro' : 'Validar Contraseña'}
                    </h3>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                    >
                        ×
                    </button>
                </div>

                {step === 1 ? (
                    <div>
                        <div className="mb-6">
                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <h3 className="text-sm font-medium text-yellow-800">
                                            Confirmación requerida
                                        </h3>
                                        <div className="mt-2 text-sm text-yellow-700">
                                            <p>¿Estás seguro de que deseas procesar el cobro para esta empresa?</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-4">
                                <h4 className="font-semibold text-gray-800 mb-2">Detalles del cobro:</h4>
                                <div className="space-y-2 text-sm">
                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Empresa:</span>
                                        <span className="font-medium">{companySelected?.nombre}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Monto a cobrar:</span>
                                        <span className="font-medium text-green-600">
                                            {formatCurrency ? formatCurrency(companySelected?.amountDue) : `$${companySelected?.amountDue}`}
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Estado actual:</span>
                                        <span className="font-medium">{PAYMENT_STATUS[companySelected?.serviceStatus] || companySelected?.serviceStatus}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="mb-6">
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <h3 className="text-sm font-medium text-blue-800">
                                            Validación de seguridad
                                        </h3>
                                        <div className="mt-2 text-sm text-blue-700">
                                            <p>Ingresa tu contraseña para autorizar el cobro.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                                    Contraseña de autorización
                                </label>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Ingresa tu contraseña"
                                    disabled={loading}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="flex justify-end space-x-3">
                    <button
                        onClick={step === 1 ? handleCancel : () => setStep(1)}
                        disabled={loading}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500"
                    >
                        {step === 1 ? 'Cancelar' : 'Atrás'}
                    </button>
                    <button
                        onClick={step === 1 ? handleConfirm : handleProcessCharge}
                        disabled={step === 1 ? false : loading || !password.trim()}
                        className="disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {step === 1
                            ? 'Continuar'
                            : (loading
                                ? (
                                    <>
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Procesando...
                                    </>
                                ) : (
                                    'Procesar Cobro'
                                ))}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChargeByCompany;